export default __webpack_public_path__ + "static/media/spike.c57cb116.png";